// extracted by mini-css-extract-plugin
export default {"table_wrapper":"employeesManageSection_table_wrapper__8sZBm","table":"employeesManageSection_table__HU1F7","remove-icon":"employeesManageSection_remove-icon__sJBJO"};